import { Routes, Route } from 'react-router-dom';
import { HashRouter } from 'react-router-dom';

// components
import Start from '../Components/Start';
import SelectMethod from '../Components/SelectMethod';
import ScanQR from '../Components/ScanQR';
import OpenMobileApp from '../Components/OpenMobileApp';
import OpenDesktopApp from '../Components/OpenDesktopApp';
import Error from '../Components/Error';
import Success from '../Components/Success';

import { URLS } from '../Utils/constants';


const Routing = () => {

    return (
        <HashRouter>
            <Routes>
                <Route path={URLS.start} element={<Start />} />
                <Route path={URLS.selectMethod} element={<SelectMethod />} />
                <Route path={URLS.scanQr} element={<ScanQR />} />
                <Route path={URLS.openMobileApp} element={<OpenMobileApp />} />
                <Route path={URLS.openDesktopApp} element={<OpenDesktopApp />} />
                <Route path={URLS.resultFailed} element={<Error />} />
                <Route path={URLS.resultSuccess} element={<Success />} />
            </Routes>
        </HashRouter>
       
   )
}

export default Routing;
